<template>
    <div>
        <div class="audithome_wrap" style="background: none;">
            <div class="audithome_head">
                <div class="audithome_hleft" style="color: #333333;">Superapoyomax</div>
                <div class="audithome_hright">
                    <div class="audithome_hrimg" @click.stop="onHomeCenter">
                        <!--<img src="../../assets/img/audithome_icon01.png" />-->
                        <!--<van-icon name="contact-o" size="24" color="#333333" />-->
                    </div>
                    <div class="audithome_hrimg" @click.stop="onHomeMenus">
                        <!--<img src="../../assets/img/audithome_icon02.png" />-->
                        <!--<van-icon name="ellipsis" size="24" color="#333333" />-->
                    </div>
                </div>
            </div>
        </div>

        <div id="statusview">
            <div class="audithome_cont">
                <div class="audithome_cview">
                    <div class="auditpass_wrap">

                        <div class="auditrejection_wrap">
                            <img class="auditrejection_bgimg" src="../../assets/img/auditwait_bgimg.png" />
                            <div class="auditrejection_cont">
                                <div class="auditpass_title">Verificando</div>
                                <div class="auditpass_desc">
                                    Hemos recibido su solicitud y la estamos verificando actualmente.
                                </div>
                                <div class="auditpass_btns">
                                    <van-button round color="#19A95C" block style="height: 1.222222rem;" @click.stop="gotoStatus">
                                        <span style="font-weight: 500;">Actualizar la página</span>
                                    </van-button>
                                </div>
                            </div>
                        </div>

                        <!--<div class="auditrejection_wrap">
                            <img class="auditrejection_bgimg" src="../../assets/img/auditrejection_bgimg.png" />
                            <div class="auditrejection_cont">
                                <div class="auditpass_title">No aprobación de préstamo</div>
                                <div class="auditpass_desc">
                                    Lo sentimos, tu solicitud de préstamo no está aprobada. Por favor, solicita de nuevo después de {{invalid_days}} días.
                                </div>
                                <div class="auditpass_btns">
                                    <van-button round color="#19A95C" block style="height: 1.222222rem;" @click.stop="onConfirm">
                                        <span style="font-weight: 500;">OK</span>
                                    </van-button>
                                </div>
                            </div>
                        </div>-->

                    </div>
                </div>
            </div>
        </div>

        <div class="auditcommon_cont">
            <div class="auditcommon_thr">
                <img src="../../assets/img/homefooter_icon05.jpg" />
            </div>
        </div>

        <van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getAccountInfo } from '@/api/apply';
    import { getLoanInfo } from '@/api/loan'

    import { Toast } from 'vant';
    import $ from 'jquery';

    export default {
        data() {
            return {
                tabactive: 0,
                orderStatus: 2,
                loanStatus: null,
                isReloan: null,
                loanInfo: {},
            }

        },
        mounted() {
            let _this = this;
            setTimeout(() => {
                client.record("login").then((r) => {
                    console.log(r);
                    //localStorage.setItem("tokenKey", r);
                    _this.$store.commit('common/SET_TOKEN_KEY', r)
                });
            }, 10);
        },
        methods: {
            onHomeMenus() {

            },
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/userstate'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { vkt_fnd_yzo } = useDataJSON;
                                //order_status, reapply_time, current_is_reloan,
                                let { omi_fje_qly, ojq_dzg_oxq, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(ojq_dzg_oxq);
                                console.log(huw_kdq_nxo);
                                console.log(xhi_cur_ovl);

                                this.getStatus(omi_fje_qly, ojq_dzg_oxq, huw_kdq_nxo, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }
                        _this.getProductListApi();

                        console.log('开始执行')

                        if(_this.isReloan == 1){
                            _this.$router.push({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.push({
                                path: '/loanpage/firstloan'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,17展期失效,21等待签约');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.push({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.push({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = null;
                                    }
                                } else {
                                    _this.isReloan = null;
                                }
                                _this.getProductListApi();

                                if(_this.isReloan == 1){
                                    _this.$router.push({
                                        path: '/loanpage/reapeatloan'
                                    });
                                } else {
                                    _this.$router.push({
                                        path: '/loanpage/firstloan'
                                    });
                                }
                            }
                        } else {
                            _this.loanStatus = 2;
                            _this.orderStatus = 1;

                            _this.$router.push({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.push({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.push({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.push({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.push({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.push({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.push({
                                path: '/loanpage/firstloan'
                            });
                        }
                        // getProductListApi();
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.push({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.push({
                                path: '/loanpage/firstloan'
                            });
                        }
                        _this.getProductListApi();
                }
            },
            getProductListApi(){

            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
        }
    }

</script>

<style lang="scss" scoped>
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }

    .infoBox {
        padding: 0.8rem 0.8rem 0.8rem 0.84rem;
        background: #ffffff;
        border-radius: 0.4rem;
        margin-bottom: 0.6rem;
        & > p {
              font-family: Roboto, Roboto;
              font-weight: 400;
              font-size: 0.52rem;
              color: #333333;
              line-height: 0.70rem;
              margin-top: 0.6rem;
          }
          h3 {
                text-align: left;
                font-family: Roboto, Roboto;
                font-weight: 700;
                font-size: 0.64rem;
                color: #333333;
                margin-bottom: 0.2rem;
          }
          ul {
            li {
                display: flex;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #333333;
                margin-bottom: 0.6rem;
                p {
                    font-family: Roboto, Roboto;
                    font-weight: 400;
                    font-size: 0.4rem;
                    color: #666666;
                }
                img {
                    width: 0.6rem;
                    height: 0.6rem;
                    margin: 0.14rem 0.2rem 0 0;
                    vertical-align: middle;
                }
            }
        }
    }

    .auditcommon_cont{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0.833333rem 0.416667rem;
    }
    .auditcommon_thr{
        width: 100%;
        height: auto;
    }
    .auditcommon_thr img{
        display: block;
        width: 100%;
    }

    #statusview .audithome_cont{
        width: 92vw;
        height: 2.1rem;
        position: relative;
        margin: 0 auto;
    }
    #statusview  .audithome_cview{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: -7.694444rem;
    }
    #statusview  .auditpass_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    .auditrejection_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    .auditrejection_bgimg{
        display: block;
        width: 100%;
    }
    .auditrejection_cont{
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        padding-top: 5.527778rem;
    }
    .auditrejection_wrap .auditpass_title{
        width: 100%;
        height: 0.972222rem;
        font-size: 0.583333rem;
        font-weight: bold;
        color: #333333;
        line-height: 0.583333rem;
        text-align: center;
    }
    .auditrejection_wrap .auditpass_desc{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.472222rem;
        text-align: center;
    }
    .auditrejection_wrap .auditpass_btns{
        width: 87%;
        height: 1.4rem;
        margin: 1.2rem auto 0 auto;
    }
</style>